import { render, staticRenderFns } from "./DeleteDirectModal.vue?vue&type=template&id=d263a380&"
import script from "./DeleteDirectModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDirectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports